import axiosInstansce from '../mainService';

const layananService = {
    getLayanans(search, page, limit,company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstansce.get(`/data/m142_services/name/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },

    totalAllServices(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstansce.get('/count-data/m142_services/name/' + sanitizedSearch + '/' + company);
    },

    deleteService(id) {
        return axiosInstansce.delete(`/delete-data/m142_services/${id}`);
    },

    addService(service) {
        return axiosInstansce.post('/insert-data/m142_services', service);
    }, 

    updateService(service) {
        return axiosInstansce.put(`/update-data/m142_services/${service.id}`, service);
    }
};

export default layananService;